var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "form-button-disabler",
    {
      attrs: {
        disabled: _vm.serviceVendorId !== null && _vm.serviceVendorId > 0,
      },
    },
    [
      _c("service-vendor-dropdown-field", {
        staticClass: "pb-2",
        attrs: {
          placeholder: "-- Select Vendor Or Type New Vendor --",
          "error-text": _vm.showValidations
            ? _vm.validations.serviceVendorId
            : "",
          taggable: "",
        },
        on: {
          organization: function ($event) {
            return _vm.setOrganization($event)
          },
        },
        model: {
          value: _vm.serviceVendorId,
          callback: function ($$v) {
            _vm.serviceVendorId = $$v
          },
          expression: "serviceVendorId",
        },
      }),
      _vm._v(" "),
      _c(
        "field",
        {
          staticClass: "pb-2",
          attrs: {
            label: "Vendor Moniker",
            "error-text": _vm.showValidations ? _vm.validations.moniker : "",
            disabled: _vm.serviceVendorId === null || _vm.serviceVendorId >= 0,
          },
        },
        [
          _c("text-field", {
            attrs: {
              placeholder:
                _vm.serviceVendorId !== null && _vm.serviceVendorId > 0
                  ? "Add Vendor Moniker"
                  : "",
            },
            model: {
              value: _vm.moniker,
              callback: function ($$v) {
                _vm.moniker = $$v
              },
              expression: "moniker",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex" },
        [
          _c("div", { staticClass: "flex-grow" }),
          _vm._v(" "),
          _c(
            "btn",
            {
              on: {
                click: function ($event) {
                  return _vm.closeProp()
                },
              },
            },
            [_vm._v("Add New Vendor")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }